import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { newDriverFaqData } from './newDriverFaqData';

import './../generalFaq.css';

const NewDriverFaq = () => (
  <div>
    <Helmet>
      <title>How Autzu Works | Autzu</title>
      <meta name="description" content="All the important information when getting started with Autzu." />
    </Helmet>
    <section className="container">
      <div className="faq__title">
        <h1>How Autzu Works</h1>
      </div>
    </section>

    {newDriverFaqData.map((data, index1) => (
      <div className="container faq__no-padding">
        <div id={`accordion${index1}`}>
          <div className="panel-heading">
            <h2 className="faq__section-title">{data.heading}</h2>
          </div>
          <div className="panel-collapse collapse in">
            <div className="panel-body">
              <div className="panel-group">
                {data.content.map((content, index2) => (
                  <div className="faq__panel">
                    <div className="faq__heading collapsed">
                      <h4 className="faq__panel--title">{content.title}</h4>
                    </div>
                    <div id={`panel${index1}Faq${index2}`} className="panel-collapse">
                      <div className="faq__panel--body">
                        {content.info.map((info, index) => {
                          // Custom Component
                          const ListComponent = info.component;
                          if (info.component) {
                            return <ListComponent />;
                          }
                          // Plain Text
                          if (info.text) {
                            return (
                              <p>
                                <b>{info.text.title}</b> <br />
                                {info.text.content}
                              </p>
                            );
                          }
                          // Text with link inside
                          if (info.link) {
                            return (
                              <p>
                                {' '}
                                {info.link.leadingText}
                                <a className="faq__panel--link" href={info.link.href}>
                                  {' '}
                                  {info.link.title}{' '}
                                </a>
                                {info.link.trailingText}
                              </p>
                            );
                          }
                          // Action button at bottom of FAQ
                          if (info.button) {
                            return (
                              <Link to={info.button.href}>
                                <button className="faq__panel--button"> {info.button.title}</button>
                              </Link>
                            );
                          }

                          if (info.list) {
                            return (
                              <div>
                                <ul>{info.list.items.map(item => <li> {item} </li>)}</ul>
                                <br />
                              </div>
                            );
                          }
                          // If Image
                          if (info.image) {
                            return (
                              <div className="faq-image__container">
                                {' '}
                                {info.image.map(image => (
                                  <div>
                                    <img className="faq-image" src={image.src} alt={image.alt} />
                                  </div>
                                ))}{' '}
                              </div>
                            );
                          }
                          if (info.video) {
                            return (
                              <div className="block-video">
                                <iframe src={info.video.src} frameBorder="0" allowFullScreen title="Instructions" />
                              </div>
                            );
                          }
                          return null;
                        })}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    ))}
  </div>
);

export default NewDriverFaq;



// WEBPACK FOOTER //
// ./src/components/Static/NewDriverFaq/index.js